import { gsap } from 'gsap';
const TL = gsap.timeline();
gsap.set(".mv-img", { opacity: 0 });
gsap.set(".mv-logo", { opacity: 0 });
gsap.set(".mv-copy", { opacity: 0 });
$(window).on('load', function () {
  TL.to(".mv-img", { delay: 0.1, duration: 1, opacity: 1, ease: "power2.inout" })
    .to(".mv-logo", { opacity: 1, duration: 1, ease: "power2.out" })
    .to(".mv-copy", { opacity: 1, duration: 2, ease: "power2.out" })
});


// $(window).on('load', function () {
//   $('.mv-sec').find('figure').addClass('is-view');
//   setTimeout(() => {
//     $('.mv-sec').find('.copy').addClass('is-view');
//     setTimeout(() => {
//       $('.mv-sec').find('.logo').addClass('is-view');
//     }, "500");
//   }, "1500");
// })
